import { Modal, ModalBody, ModalHeader, ROLE } from 'baseui/modal'
import React from 'react'
import { useFullScreenImageStore } from './FullScreenImageStore'
import styles from './FullScreenImage.module.css'

export const FullScreenImage = () => {
    const { closeFullScreenImage, isOpenFullScreenImage, imageSrc, imgTitle, maxSize } = useFullScreenImageStore(
        (state) => state
    )
    return (
        <div className={styles.root}>
            <Modal
                onClose={() => {
                    closeFullScreenImage()
                }}
                closeable
                isOpen={isOpenFullScreenImage}
                animate
                autoFocus
                size={maxSize ?? '80vw'}
                role={ROLE.alertdialog}
            >
                <ModalHeader>{imgTitle}</ModalHeader>
                <ModalBody>
                    <img className={styles.image} alt="" src={imageSrc} />
                </ModalBody>
            </Modal>
        </div>
    )
}
